import React from 'react';
import { Alert } from 'antd';

import { CandidateProjectMatchDetail } from './matching.types';
import { blockedExplanation, isUpdateFailed, updatingLabel } from './matchingPresentation';
import { MatchingProcessingNotice } from './MatchingStatus';

// Combine overlapping warnings into one readable notice; stage details stay collapsed.
export const MatchDetailStatus = ({ data }: { data: CandidateProjectMatchDetail }) => {
  if (!data.assessment) return data.processingActive ? null : <MatchingProcessingNotice {...data} />;
  const { freshness, processing } = data;
  const reasons = [
    freshness?.candidateChanged && 'Candidate data changed.',
    freshness?.projectChanged && 'Project requirements changed.',
    freshness?.assessmentVersionKnown && freshness.assessmentVersionChanged && 'The assessment version changed.',
    freshness && !freshness.assessmentVersionKnown && 'Assessment version could not be verified.',
    processing.blockedReason && blockedExplanation(processing.blockedReason),
    (!data.processingEnabled || data.processingBlockedReason) &&
      'Matching updates are paused. The stored assessment remains available.',
    // A blocked reason already explains a failed stage status.
    isUpdateFailed(processing) && 'The last update failed. The stored assessment remains available.',
  ].filter((reason): reason is string => !!reason);
  const updating = updatingLabel(processing) || (data.processingActive ? 'Matching is in progress' : null);
  if (reasons.length || freshness?.stale)
    return (
      <Alert
        type="warning"
        showIcon
        message={freshness?.stale ? 'This assessment may be out of date' : 'Review assessment availability'}
        description={
          <>
            {reasons.length > 0 && (
              <ul className="matching-reasons">
                {reasons.map((reason) => (
                  <li key={reason}>{reason}</li>
                ))}
              </ul>
            )}
            {updating && <div>{updating}. This page updates automatically while processing continues.</div>}
          </>
        }
      />
    );
  if (updating)
    return (
      <Alert
        type="info"
        showIcon
        message={updating}
        description="This page updates automatically while this pair is processing. The stored assessment is available below."
      />
    );
  return null;
};
